<template>
  <section>
    <div class="row">
      <div class="builder__col builder__col--data col-lg-6">
        <div class="row data__col">
          <div class="builder__back col-10 offset-1">
            <router-link class="global__btn" to="/">BACK</router-link>
            <a
              href
              class="global__btn retry__btn"
              @click.prevent="refresh()"
              v-if="this.images.length > 0"
            >RETRY</a>
          </div>
          <form class="builder__username col-10 offset-1" @submit.prevent="getInstaFeed()">
            <label for="username">Enter your Instagram username</label>
            <div>
              <input
                name="username"
                type="text"
                v-model="username"
                :class="`${error ? 'error' : ''}`"
                :disabled="this.images.length > 0 ? 'disabled' : false"
              >
            </div>
            <div>
              <button
                class="global__btn"
                type="submit"
                :disabled="this.images.length > 0 ? 'disabled' : false"
              >Confirm</button>
            </div>
          </form>
        </div>
        <div class="row data__col data__col--gallery" v-if="this.images.length > 0">
          <p class="gallery__title col-10 offset-1">Choose a photo to generate your watch</p>
          <div class="gallery__container">
            <div class="gallery__content">
              <div
                class="gallery__image"
                v-for="(_image, index) in this.images"
                :class="`${currentImage == index ? 'active' : ''}`"
                :key="index"
                @click="loadData(index)"
              >
                <img :src="_image.src" crossorigin="anonymous" :data-index="`image-${index}`">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`builder__col builder__col--watch col-lg-6 ${this.choosenPalette ? '' : 'inactive'}`"
      >
        <div class="row">
          <div class="col-12 builder__watch">
            <div class="watch__dial">
              <div id="p5_loading"></div>
              <Sketch
                v-if="this.choosenPalette"
                :username="username"
                :displayName="this.displayName"
                :data="this.choosenPalette"
              ></Sketch>
            </div>
            <img src="../assets/images/mock-up-big.png" alt>
          </div>
        </div>
        <div class="row">
          <a href="https://www.swatch.com" target="_blank" class="col-12 buy__cta">Buy my swatch</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import * as Vibrant from "node-vibrant";
import Sketch from "../components/Sketch";
export default {
  name: "Experience",
  components: {
    Sketch
  },
  data() {
    return {
      username: "",
      error: false,
      displayName: "",
      images: [],
      currentImage: -1,
      choosenPalette: null
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    refresh() {
      window.location.reload();
    },
    getInstaFeed() {
      axios
        .get(`https://syo-api.now.sh?username=${this.username}`)
        .then(res => {
          if (res.data.images.length > 0) {
            this.error = false;
            res.data.images.forEach(image => {
              this.images.push({
                src: image,
                palette: null
              });
            });
            this.displayName = res.data.displayName;
          } else {
            this.error = true;
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
    loadData(index) {
      const node = document.querySelector(`img[data-index="image-${index}"`);
      Vibrant.from(node).getPalette((err, palette) => {
        const destructuredPalette = {};
        Object.keys(palette).forEach(key => {
          destructuredPalette[key] = `rgb(${Math.floor(
            palette[key].rgb[0]
          )},${Math.floor(palette[key].rgb[1])},${Math.floor(
            palette[key].rgb[2]
          )})`;
        });
        this.choosenPalette = destructuredPalette;
        this.currentImage = index;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/helpers/utilities.scss";

.builder__col {
  height: 100vh;
  min-height: 700px;
  &.inactive {
    pointer-events: none;
    opacity: 0.5;
  }
  .retry__btn {
    margin-left: 30px;
  }
  &.builder__col--data {
    .data__col {
      height: 50%;
      padding: 25px 0px 50px 0px;
      .builder__username {
        margin-top: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        label {
          color: $darkenColor;
          font-size: 14px;
          margin-bottom: 15px;
        }
        input {
          border: none;
          color: $darkenColor;
          border-bottom: 2px solid rgba($darkenColor, 0.4);
          width: 50%;
          font-size: 22px;
          height: 50px;
          outline: none;
          margin-bottom: 30px;
          &.error {
            border-bottom: 2px solid rgba(red, 0.4);
          }
        }
      }
      &.data__col--gallery {
        padding: 50px 0px;
        background: rgba($darkenColor, 0.18);
        .gallery__title {
          color: $darkenColor;
        }
        .gallery__container {
          width: 100%;
          height: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;
          overflow-x: scroll;
          &::-webkit-scrollbar {
            width: 2px;
            height: 7px;
          }

          /* Track */
          &::-webkit-scrollbar-track {
            background: rgba($darkenColor, 0.18);
          }

          /* Handle */
          &::-webkit-scrollbar-thumb {
            background: $darkenColor;
          }

          /* Handle on hover */
          &::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          .gallery__content {
            display: inline-flex;
            padding-left: 8.33333%;
            padding-right: 8.33333%;

            .gallery__image {
              margin: 0px 25px;
              height: 250px;
              width: 250px;
              border: 5px solid rgba($darkenColor, 0);
              cursor: pointer;
              &:first-of-type {
                margin-left: 0px;
              }
              &.active {
                border: 5px solid $darkenColor;
              }
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
  &.builder__col--watch {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .builder__watch {
    height: calc(100vh - 75px);
    text-align: center;
    position: relative;
    .watch__dial {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(calc(-50% - 7px), calc(-50% - 42px));
      z-index: -1;
    }
    img {
      height: 100%;
      width: 370px;
      object-fit: cover;
    }
  }
  .buy__cta {
    background: $darkenColor;
    height: 75px;
    color: white;
    text-transform: uppercase;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-size: 16px;
  }
}
</style>

